import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
/* src/app/component.nav.sidebar/view.scss: no such file or directory */`],
})
export class ComponentNavSidebarComponent implements OnInit {
    private readonly settingsReturnKey: string = 'inspection.settings.returnUrl';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    @HostListener('document:click')
    public clickout() {
        this.service.status.toggle('navbar', true);
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    public activeClass(link: string) {
        if (this.isActive(link)) {
            return "group flex gap-x-2 items-center rounded-md bg-gray-100 px-2 py-1.5 text-[13px] font-medium text-indigo-600";
        }
        return "group flex gap-x-2 items-center rounded-md px-2 py-1.5 text-[13px] font-medium text-gray-600 hover:bg-gray-50 hover:text-indigo-600";
    }

    public isAdminRole() {
        return ['admin', 'superadmin'].includes(this.service.auth.session?.role);
    }

    private getCurrentUrl(): string {
        return `${location.pathname}${location.search || ''}${location.hash || ''}`;
    }

    private safeInspectionUrl(url: any): string {
        const value = String(url || '').trim();
        if (!value || value.startsWith('//')) return '';
        if (value === '/chatbot' || value.startsWith('/chatbot/') || value.startsWith('/chatbot?') || value.startsWith('/chatbot#')) return value;
        return '';
    }

    public openSettings(event?: Event) {
        if (event) event.preventDefault();
        const returnUrl = this.safeInspectionUrl(this.getCurrentUrl());
        try {
            if (returnUrl) {
                sessionStorage.setItem(this.settingsReturnKey, returnUrl);
            }
        } catch (e) { }
        const target = returnUrl
            ? `/admin/settings?return=${encodeURIComponent(returnUrl)}`
            : '/admin/settings';
        this.service.href(target);
    }
}

export default ComponentNavSidebarComponent;